module.exports = __webpack_public_path__ + "img/jinan.eada1b22.jpg";